import FAQAccordion from '@/components/react/FAQAccordion';
import { trackContactClick } from '@/lib/analytics';

export function FAQ() {
  return (
    <section id="faq" className="py-20 lg:py-28 bg-white">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-12">
          <span className="text-gold-600 font-semibold text-sm uppercase tracking-wider">Dúvidas Frequentes</span>
          <h2 className="text-3xl sm:text-4xl font-bold text-navy-900 mt-3 mb-4">
            Perguntas Frequentes
          </h2>
          <p className="text-lg text-neutral-600">
            Tire suas principais dúvidas sobre holdings patrimoniais e nossos serviços.
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="max-w-3xl mx-auto">
          <FAQAccordion />
        </div>

        {/* Additional CTA */}
        <div className="text-center mt-12">
          <p className="text-neutral-600 mb-4">Não encontrou sua resposta?</p>
          <a
            href="#contato"
            onClick={() => trackContactClick('whatsapp', 'faq')}
            className="inline-flex items-center gap-2 text-gold-600 font-semibold hover:text-gold-700 transition-colors"
          >
            Fale com um especialista
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
}
